import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home';
import { authGuard } from './guards/auth-guard';
import { LoginComponent } from './pages/login/login';
import { RegisterComponent } from './pages/register/register';
import { LayoutComponent } from './components/layout/layout';
import { CheckoutComponent } from './pages/checkout/checkout';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  {
    path: 'checkout/:id',
    component: CheckoutComponent,
    canActivate: [authGuard],
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'home',
        loadComponent: () =>
          import('./pages/home/home').then((m) => m.HomeComponent),
      },
      {
        path: 'used-passes',
        loadComponent: () =>
          import('./pages/used-passes/used-passes').then(
            (m) => m.UsedPassesComponent
          ),
      },
      {
        path: 'purchases',
        loadComponent: () =>
          import('./pages/purchases/purchases').then(
            (m) => m.PurchasesComponent
          ),
      },
      {
        path: 'bulk-purchase',
        loadComponent: () =>
          import('./pages/bulk-purchase/bulk-purchase').then(
            (m) => m.BulkPurchaseComponent
          ),
      },
      {
        path: 'company-users',
        loadComponent: () =>
          import('./pages/company-users/company-users').then(
            (m) => m.CompanyUsersComponent
          ),
      },
      {
        path: 'downloads',
        loadComponent: () =>
          import('./pages/downloads/downloads').then(
            (m) => m.DownloadsComponent
          ),
      },
      {
        path: 'reports',
        loadComponent: () =>
          import('./pages/reports/reports').then((m) => m.ReportsComponent),
      },
      { path: '', redirectTo: 'home', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: 'login' }, // Wildcard route for a 404 page or redirect
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
